module.exports = __webpack_public_path__ + "img/natural_gas.a52f0a2a.jpg";